"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateTabSaga = activateTabSaga;
exports.requestRemoveTabSaga = requestRemoveTabSaga;
exports.removeTabSaga = removeTabSaga;
exports.openTabSaga = openTabSaga;
const redux_saga_1 = require("redux-saga");
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
function* activateTabSaga() {
    while (true) {
        const action = yield redux_saga_1.effects.take("tabs/ACTIVATE_TAB");
        redux_saga_1.effects.put(GlobalActions.tabActivated(action.payload));
    }
}
function* requestRemoveTabSaga() {
    while (true) {
        const action = yield redux_saga_1.effects.take("tabs/REQUEST_REMOVE_TAB");
        const tabToRemove = action.payload;
        yield redux_saga_1.effects.put(GlobalActions.removeTab(tabToRemove));
        const openTabsAfterRemove = yield redux_saga_1.effects.select((state) => state.ui.mainShell.openTabs);
        if (openTabsAfterRemove.length > 0) {
            yield redux_saga_1.effects.put(GlobalActions.tabActivated(openTabsAfterRemove[openTabsAfterRemove.length - 1]));
        }
        yield redux_saga_1.effects.put(GlobalActions.tabRemoved(tabToRemove.subject));
    }
}
function* removeTabSaga() {
    while (true) {
        const action = yield redux_saga_1.effects.take("global-actions/REQUEST_CLOSE_TAB_FROM_SUBJECT");
        const subject = action.payload;
        const openTabs = yield redux_saga_1.effects.select((state) => state.ui.mainShell.openTabs);
        const tabToRemove = openTabs.find(t => isSubjectsEqual(t.subject, subject));
        if (!tabToRemove) {
            return;
        }
        yield redux_saga_1.effects.put(GlobalActions.removeTab(tabToRemove));
        const openTabsAfterRemove = yield redux_saga_1.effects.select((state) => state.ui.mainShell.openTabs);
        if (openTabsAfterRemove.length > 0) {
            yield redux_saga_1.effects.put(GlobalActions.tabActivated(openTabsAfterRemove[openTabsAfterRemove.length - 1]));
        }
        yield redux_saga_1.effects.put(GlobalActions.tabRemoved(tabToRemove.subject));
    }
}
function* openTabSaga() {
    while (true) {
        const action = yield redux_saga_1.effects.take("global-actions/REQUEST_OPEN_TAB");
        const openTabs = yield redux_saga_1.effects.select((state) => state.ui.mainShell.openTabs);
        const matchingTab = openTabs.find(tab => isSubjectsEqual(tab.subject, action.payload.subject));
        if (matchingTab) {
            yield redux_saga_1.effects.put(GlobalActions.tabActivated(matchingTab));
        }
        else {
            yield redux_saga_1.effects.put(GlobalActions.tabOpened({
                title: action.payload.title,
                openTabSpecification: action.payload
            }));
        }
    }
}
function isSubjectsEqual(subject1, subject2) {
    return JSON.stringify(subject1) === JSON.stringify(subject2);
}
//# sourceMappingURL=saga.js.map